/** @format */

import { SVGProps } from 'react';

const WarningIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={16}
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      d='M.725 16 10 0l9.275 16H.725ZM9.5 11.375h1v-5h-1v5Zm.5 2.25a.602.602 0 0 0 .438-.187.602.602 0 0 0 .187-.438.602.602 0 0 0-.187-.438.602.602 0 0 0-.438-.187.602.602 0 0 0-.438.187.602.602 0 0 0-.187.438.6.6 0 0 0 .187.438.602.602 0 0 0 .438.187Z'
      fill='#A77A07'
    />
  </svg>
);
export default WarningIcon;
